// extracted by mini-css-extract-plugin
module.exports = {"callUs_banner":"styles_callUs_banner__1Snmr","phone":"styles_phone__2N9_F"};